import { render, staticRenderFns } from "./WagonRevisionDeadline.vue?vue&type=template&id=ff2c07a4&scoped=true"
import script from "./WagonRevisionDeadline.vue?vue&type=script&lang=js"
export * from "./WagonRevisionDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c07a4",
  null
  
)

export default component.exports